import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../../../Seller/Sidebar';
import ProfileEdit from '../Profile/ProfileEdit';

const ProfilePropEdit = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        background: '#f9fafb',
        gap: '20px',
        flexDirection: { xs: 'column', md: 'row' },
        mt: { xs: '64px', md: '15px' },
      }}
    >
      {/* ✅ Hide Sidebar on mobile */}
      {!isMobile && <Sidebar />}

      <ProfileEdit />
    </Box>
  );
};

export default ProfilePropEdit;